<template>
  <div
    v-if="channels && $login.can('channels.view')"
    class="channels-list"
  >
    <page-header header="Channels">
      <router-link
        v-if="$login.can('channels.create')"
        :to="{ name: 'channels.create' }"
        class="btn btn-primary"
      >
        Create Channel
      </router-link>
    </page-header>

    <div class="mt-3">
      <search
        class="mb-3"
        v-model="params.search"
      />
      <vue-good-table
        :rows="channels"
        :columns="tableColumns"
        @on-row-click="({ row }) => $router.push({name: 'channels.view', params: { channelId: row.id }})"
        styleClass="vgt-table"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'before'">
            <div style="width: 3rem;height:3rem;">
              <div
                :style="`background-image: url('${props.row.logo_url}')`"
                class="background-cover"
              />
            </div>
          </span>
          <span v-else-if="props.column.field == 'website'">
            <a
              :href="props.row.url"
              target="_blank"
            >
              {{ props.row.url.replace(/^(https?:\/\/)?(www\.)?/, '').replace(/\/$/, '') }}
            </a>
          </span>
          <span v-else-if="props.column.field == 'email'">
            <a
              :href="`mailto:${props.row.email}`"
              target="_blank"
            >
              {{ props.row.email ? props.row.email.replace(/^(https?:\/\/)?(www\.)?/, '').replace(/\/$/, '') : '' }}
            </a>
          </span>
          <span v-else-if="props.column.field == 'phone'">
            <a
              v-if="props.row.default_address"
              :href="`tel:${props.row.default_address.phone}`"
              target="_blank"
            >
              {{ props.row.default_address.phone }}
            </a>

            <span v-else>
              -
            </span>
          </span>
          <span v-else-if="props.column.field == 'baseCountry'">
            <span
              v-if="props.row.default_address"
              v-tooltip="props.row.default_address.country.name"
              :class="`flag-icon-${props.row.default_address.country.alpha_2_code.toLowerCase()}`"
              class="flag-icon"
            />
            <span v-else>
              -
            </span>
          </span>
          <span v-else-if="props.column.field == 'coveredCountries'">
            <span
              v-for="country in props.row.countries"
              v-tooltip="country.name"
              :key="country.id"
              :class="`flag-icon-${country.alpha_2_code.toLowerCase()}`"
              class="flag-icon mr-1"
            />
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>

      <pagination
        :data="pagination"
        :disabled="loading"
        @change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axios from '@/axios'
import {createHttpQuery} from '@/helpers'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'
import {successNotification} from '@/notifications'

const defaultPagination = {
  page: 1,
  full: 1,
  populate: [
    'default_address',
    'countries',
  ],
  search: null,
}

export default {
  components: {
    Search,
    Pagination,
    VueGoodTable,
  },

  metaInfo () {
    return {
      title: 'Channels',
    }
  },

  data () {
    return {
      pagination: null,
      params: defaultPagination,
      showActions: [],
      drafts: [],
      channels: [],
      loading: false,
      channel: null,
      tableColumns: [
        {
          label: '',
          field: 'before',
        },
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Website',
          field: 'website',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Base Country',
          field: 'baseCountry'
        },
        {
          label: 'Covered countries',
          field: 'coveredCountries'
        },
      ],
    }
  },

  watch: {
    params: {
      deep: true,
      handler () {
        this.getChannels()
      },
    },

    channel () {
      this.params.channel_id = this.channel.id
    },
  },

  created () {
    this.getChannels()
  },

  methods: {
    async getChannels () {
      this.loading = true

      const params = createHttpQuery(this.params)
      const {data: channels} = await axios.get('/channels', {params})
      this.pagination = channels.meta
      this.channels = channels.data

      if (this.channels) {
        this.channels.forEach((channel) => {
          channel.showActions = false
        })
      }

      this.loading = false
    },

    changePage (page) {
      this.params.page = page
    },

    clearAll () {
      this.params.channel_id = null
    },

    confirmDelete (channel) {
      this.$notify({
        group: 'confirm',
        type: 'error',
        title: 'Are you sure you want to delete ' + channel.name + '?',
        data: {
          onConfirm: () => {
            this.$http.delete('/channels/' + channel.id)
                .then((response) => {
                  if (!this.params.show_deleted) {
                    this.channels.splice(this.channels.indexOf(channel), 1)
                  } else {
                    this.channels[this.channels.indexOf(channel)] = response.data
                  }
                  this.$notify(successNotification(`Deleted ${channel.name}.`))
                })
          },
        },
      })
    },

    restore (channel) {
      this.$http.patch('/channels/' + channel.id + '/restore')
          .then((response) => {
            this.channels[this.channels.indexOf(channel)] = response.data
            this.$notify(successNotification(`Restored ${channel.name}.`))
          })
    },

    selectedChannel (selected) {
      this.params.channel_id = selected ? selected.object.id : null
    },
  },
}
</script>

<style lang="scss">
.channels-list {
  .el-table {
    td {
      padding: 0;
    }
  }
}
</style>

